/**
 * Shopify Customer Privacy fallback for stores where Pandectes Core's app
 * embed is missing. Pandectes remains preferred: if its v5 web component is
 * present, this surface stays disabled.
 */
(function () {
  if (window.__sidekickPrivacyFallbackLoaded) return;
  window.__sidekickPrivacyFallbackLoaded = true;

  var CMP_SELECTOR = 'pandectes-cmp';
  var root;
  var banner;
  var widget;
  var dialog;
  var form;
  var status;
  var bannerStatus;
  var gpcNotice;
  var cp = null;
  var fallbackActive = false;

  function q(selector) {
    return root && root.querySelector(selector);
  }

  function hasPandectesCmp() {
    return Boolean(document.querySelector(CMP_SELECTOR));
  }

  function statusTarget(surface) {
    if (surface === 'banner') return bannerStatus || status;
    if (dialog && (dialog.open || dialog.hasAttribute('open'))) return status || bannerStatus;
    if (banner && !banner.hidden) return bannerStatus || status;
    return status || bannerStatus;
  }

  function setStatus(message, surface) {
    var target = statusTarget(surface);
    var others = [status, bannerStatus];
    for (var i = 0; i < others.length; i += 1) {
      if (others[i] && others[i] !== target) others[i].textContent = '';
    }
    if (target) target.textContent = message || '';
  }

  function currentConsent() {
    if (!cp || typeof cp.currentVisitorConsent !== 'function') return {};
    try {
      return cp.currentVisitorConsent() || {};
    } catch (error) {
      return {};
    }
  }

  function consentIsYes(value) {
    return value === true || value === 'yes' || value === 'granted';
  }

  function consentHasAnswer(value) {
    return (
      value === true ||
      value === false ||
      value === 'yes' ||
      value === 'no' ||
      value === 'granted' ||
      value === 'denied'
    );
  }

  function hasCompletedCookieConsent() {
    var current = currentConsent();
    return (
      consentHasAnswer(current.preferences) &&
      consentHasAnswer(current.analytics) &&
      consentHasAnswer(current.marketing) &&
      consentHasAnswer(current.sale_of_data)
    );
  }

  function syncInputs() {
    var current = currentConsent();
    var preferences = q('[data-sk-consent-preferences]');
    var analytics = q('[data-sk-consent-analytics]');
    var marketing = q('[data-sk-consent-marketing]');
    var sale = q('[data-sk-consent-sale]');

    if (preferences) preferences.checked = consentIsYes(current.preferences);
    if (analytics) analytics.checked = consentIsYes(current.analytics);
    if (marketing) marketing.checked = consentIsYes(current.marketing);
    if (sale) {
      sale.checked = consentIsYes(current.sale_of_data);
      if (navigator.globalPrivacyControl === true) {
        sale.checked = false;
        sale.disabled = true;
      }
    }
  }

  function hideBanner() {
    if (banner) banner.hidden = true;
    if (widget) widget.hidden = false;
  }

  function showBanner() {
    if (!fallbackActive || !banner) return;
    banner.hidden = false;
    if (widget) widget.hidden = true;
  }

  function openPreferences() {
    if (!fallbackActive || !dialog) return;
    syncInputs();
    setStatus('');
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closePreferences() {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  function setConsent(values) {
    return new Promise(function (resolve, reject) {
      if (!cp || typeof cp.setTrackingConsent !== 'function') {
        reject(new Error('Privacy controls are still loading. Please try again.'));
        return;
      }

      try {
        cp.setTrackingConsent(values, function (result) {
          if (result && result.error) {
            reject(new Error('We could not save your choices. Please try again.'));
            return;
          }
          resolve();
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  function withGpc(values) {
    var next = values || {};
    if (navigator.globalPrivacyControl === true) next.sale_of_data = false;
    return next;
  }

  function save(values, button, surface) {
    setStatus('Saving your choices…', surface);
    if (button) button.disabled = true;

    setConsent(withGpc(values))
      .then(function () {
        setStatus('Your privacy choices have been saved.', surface);
        window.setTimeout(function () {
          hideBanner();
          closePreferences();
        }, 700);
      })
      .catch(function (error) {
        setStatus(
          error && error.message ? error.message : 'We could not save your choices. Please try again.',
          surface
        );
      })
      .finally(function () {
        if (button) button.disabled = false;
      });
  }

  function activateFallback() {
    if (fallbackActive || hasPandectesCmp() || !root) return;
    fallbackActive = true;
    root.hidden = false;

    var shouldShow = false;
    try {
      shouldShow = typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner() === true;
    } catch (error) {}

    // Shopify can report shouldShowBanner() as true in theme preview even after
    // all three cookie categories have explicit stored answers.
    if (shouldShow && !hasCompletedCookieConsent()) {
      showBanner();
    } else if (widget) {
      widget.hidden = false;
    }
  }

  function disableFallback() {
    fallbackActive = false;
    if (root) root.hidden = true;
    closePreferences();
  }

  function initialiseCustomerPrivacy() {
    var tries = 0;

    function ready() {
      cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.setTrackingConsent === 'function') {
        // Give the preferred Pandectes app embed time to attach its web component.
        window.setTimeout(function () {
          if (hasPandectesCmp()) {
            disableFallback();
          } else {
            activateFallback();
          }
        }, 1200);
        return;
      }

      if (++tries < 200) {
        window.setTimeout(ready, 50);
      } else {
        // Keep tracking fail-closed, but expose the UI with a useful error.
        fallbackActive = true;
        root.hidden = false;
        showBanner();
        setStatus('Privacy controls could not load. Please refresh the page.');
      }
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function () {
          ready();
        }
      );
    } else {
      ready();
    }
  }

  function onReady() {
    root = document.querySelector('[data-sk-privacy]');
    if (!root) return;

    banner = q('[data-sk-privacy-banner]');
    widget = q('[data-sk-privacy-widget]');
    dialog = q('[data-sk-privacy-dialog]');
    form = q('[data-sk-privacy-form]');
    status = q('[data-sk-privacy-status]');
    bannerStatus = q('[data-sk-privacy-banner-status]');
    gpcNotice = q('[data-sk-privacy-gpc]');

    if (gpcNotice && navigator.globalPrivacyControl === true) {
      gpcNotice.hidden = false;
    }

    root.addEventListener('click', function (event) {
      var target = event.target.closest('button');
      if (!target) return;

      if (target.matches('[data-sk-privacy-accept]')) {
        save(
          { preferences: true, analytics: true, marketing: true, sale_of_data: true },
          target,
          banner && banner.contains(target) ? 'banner' : 'dialog'
        );
      } else if (target.matches('[data-sk-privacy-reject]')) {
        save(
          { preferences: false, analytics: false, marketing: false, sale_of_data: false },
          target,
          banner && banner.contains(target) ? 'banner' : 'dialog'
        );
      } else if (target.matches('[data-sk-privacy-manage], [data-sk-privacy-widget]')) {
        openPreferences();
      } else if (target.matches('[data-sk-privacy-close]')) {
        closePreferences();
      }
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        save(
          {
            preferences: Boolean(q('[data-sk-consent-preferences]')?.checked),
            analytics: Boolean(q('[data-sk-consent-analytics]')?.checked),
            marketing: Boolean(q('[data-sk-consent-marketing]')?.checked),
            sale_of_data: Boolean(q('[data-sk-consent-sale]')?.checked),
          },
          q('[data-sk-privacy-save]'),
          'dialog'
        );
      });
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href="#reopenBanner"]');
      if (!link || hasPandectesCmp()) return;
      event.preventDefault();
      openPreferences();
    });

    window.addEventListener('hashchange', function () {
      if (location.hash === '#reopenBanner' && !hasPandectesCmp()) {
        openPreferences();
      }
    });

    // If the app embed is enabled later or attaches slowly, always defer to it.
    new MutationObserver(function () {
      if (hasPandectesCmp()) disableFallback();
    }).observe(document.documentElement, { childList: true, subtree: true });

    initialiseCustomerPrivacy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }
})();
